"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TITLE_POSITION_VALUES = void 0;
var TITLE_POSITION_VALUES;
(function (TITLE_POSITION_VALUES) {
    TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["CENTER"] = 1] = "CENTER";
    TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["BOTTOM"] = 2] = "BOTTOM";
})(TITLE_POSITION_VALUES = exports.TITLE_POSITION_VALUES || (exports.TITLE_POSITION_VALUES = {}));
//# sourceMappingURL=title-position-values.js.map